import { render, staticRenderFns } from "./Plus.vue?vue&type=template&id=32e0aca8&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32e0aca8')) {
      api.createRecord('32e0aca8', component.options)
    } else {
      api.reload('32e0aca8', component.options)
    }
    module.hot.accept("./Plus.vue?vue&type=template&id=32e0aca8&", function () {
      api.rerender('32e0aca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Plus.vue"
export default component.exports